import { MutationTree } from 'vuex';
import { HealthcareManagementUI } from './state';


const mutation: MutationTree<HealthcareManagementUI> = {
   //

}

export default mutation;